import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import { sameId, scopeLabel, suggestedCard } from './model';

function planHelper(value, node, cards, suggested) {
  const selected = cards.find((card) => sameId(card.id, value));
  const needsChoice = !selected && (cards.length > 1 || node.plan_reason === 'ambiguous');
  if (needsChoice) {
    return {
      error: true,
      text: suggested ? `Выберите одну из ${cards.length} · по размеру подходит «${suggested.name}»` : `Выберите одну из ${cards.length}`,
    };
  }
  // Область действия знает только сервер (plan_scope): параметрика на родителе — семья,
  // та же параметрика на модификации — только она.
  const scope = selected ? scopeLabel(node.plan_scope) : '';
  if (node.plan_reason === 'single' && selected) {
    return {
      error: false,
      text: scope ? `Единственная — выбрана автоматически · ${scope}` : 'Единственная — выбрана автоматически',
    };
  }
  if (scope) return { error: false, text: scope };
  return { error: false, text: ' ' };
}

/**
 * Выбор техкарты для узла дерева семьи (targetId = planTargetId: единственный член или ключ слота) или модификации
 * (targetId = ms_id). onChange(targetId, planId|null, node) → PUT /tech-chain/plan (node.members → member_ids).
 */
function MemberPlans({ plans }) {
  return (
    <Box>
      {plans.map((plan) => (
        <Typography key={plan.ms_id} variant="caption" display="block">
          {plan.name} → {plan.plan_name || 'не выбрана'}
        </Typography>
      ))}
    </Box>
  );
}

export default function TechcardSelect({ node, targetId, saving, onChange }) {
  const cards = Array.isArray(node?.cards) ? node.cards : [];
  if (node?.plan_reason === 'per_member') {
    const plans = Array.isArray(node.member_plans) ? node.member_plans : [];
    return (
      <Tooltip title={plans.length ? <MemberPlans plans={plans} /> : ''}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ cursor: 'help', textDecoration: 'underline dotted' }}
        >
          карта по размеру
        </Typography>
      </Tooltip>
    );
  }
  if (!cards.length) {
    return (
      <Typography variant="caption" color="text.secondary">
        {node?.has_card ? 'техкарта у модификаций' : 'без техкарты'}
      </Typography>
    );
  }
  const selectedCard = cards.find((card) => sameId(card.id, node.plan_id));
  const value = selectedCard ? selectedCard.id : '';
  const suggested = suggestedCard(node);
  const helper = planHelper(value, node, cards, suggested);
  return (
    <FormControl size="small" fullWidth error={helper.error} disabled={saving} margin="dense">
      <InputLabel>Техкарта</InputLabel>
      <Select
        label="Техкарта"
        value={value}
        onChange={(event) => onChange(targetId, event.target.value || null, node)}
        renderValue={(id) => cards.find((card) => sameId(card.id, id))?.name || 'Не выбрана'}
      >
        <MenuItem value=""><em>Не выбрана</em></MenuItem>
        {cards.map((card) => (
          <MenuItem key={card.id} value={card.id}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="body2">{card.name}</Typography>
              <Typography variant="caption" color="text.secondary">
                {card.is_parametric ? 'параметрическая' : 'обычная'}
                {suggested && sameId(suggested.id, card.id) ? ' · по размеру' : ''}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
      <FormHelperText sx={{ mx: 0 }}>{helper.text}</FormHelperText>
    </FormControl>
  );
}
